import { render } from "./KidFooter.vue?vue&type=template&id=49064f44&scoped=true"
import script from "./KidFooter.vue?vue&type=script&lang=js"
export * from "./KidFooter.vue?vue&type=script&lang=js"

import "./KidFooter.vue?vue&type=style&index=0&id=49064f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49064f44"]])

export default __exports__